/**
 * Sub Navigation Component
 * Handles fixed positioning on scroll + Swiper carousel (prev/next)
 */
export class SubNav {
    constructor() {
        this.subNav = null;
        this.anchorEl = null;
        this.offsetTop = 0;
        this.isFixed = false;
        this.swiper = null;
        this.init();
    }

    init() {
        const carousel = document.getElementById("sub-nav-swiper");
        this.subNav =
            document.getElementById("sub-nav") ||
            carousel?.closest(".no-sub-nav");

        if (!this.subNav || !carousel) return;

        this.anchorEl = this.subNav.previousElementSibling;

        // Swiper 초기화 (prev/next 버튼)
        if (carousel && typeof Swiper !== "undefined") {
            const navRoot = carousel.closest(".no-sub-nav");
            const prevEl = navRoot?.querySelector(".no-sub-nav__button--prev");
            const nextEl = navRoot?.querySelector(".no-sub-nav__button--next");
            const containerEl = carousel.closest(".no-sub-nav__container");

            const updateNavButtonsVisibility = () => {
                if (!navRoot || !containerEl) return;
                const wrapper = carousel.querySelector(".swiper-wrapper");
                if (!wrapper) return;
                const containerWidth = containerEl.clientWidth;
                const contentWidth = wrapper.scrollWidth;
                const hasOverflow = contentWidth > containerWidth;
                navRoot.classList.toggle("--no-overflow", !hasOverflow);
            };

            this.swiper = new Swiper(carousel, {
                slidesPerView: "auto",
                spaceBetween: 8,
                watchOverflow: true,
                navigation: prevEl && nextEl ? { prevEl, nextEl } : false,
                on: {
                    init() {
                        const activeIndex = this.slides.findIndex((s) =>
                            s.classList.contains("--active"),
                        );
                        if (activeIndex !== -1) this.slideTo(activeIndex);
                        requestAnimationFrame(() => {
                            requestAnimationFrame(updateNavButtonsVisibility);
                        });
                    },
                },
            });

            window.addEventListener("resize", updateNavButtonsVisibility);
        }

        if (this.anchorEl) {
            this.calculateOffset();
            this.initScrollHandler();
            window.addEventListener("resize", () => this.calculateOffset());
        }
    }

    calculateOffset() {
        if (!this.anchorEl || !this.subNav) return;
        const anchorRect = this.anchorEl.getBoundingClientRect();
        const navRect = this.subNav.getBoundingClientRect();
        const scrollTop =
            window.pageYOffset || document.documentElement.scrollTop;
        this.offsetTop =
            anchorRect.top + scrollTop + anchorRect.height - navRect.height;
    }

    initScrollHandler() {
        let ticking = false;

        const handleScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    const scrollTop =
                        window.pageYOffset ||
                        document.documentElement.scrollTop;

                    if (scrollTop >= this.offsetTop && !this.isFixed) {
                        this.subNav.classList.add("--fixed");
                        this.isFixed = true;
                    } else if (scrollTop < this.offsetTop && this.isFixed) {
                        this.subNav.classList.remove("--fixed");
                        this.isFixed = false;
                    }

                    ticking = false;
                });

                ticking = true;
            }
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
    }
}
